module.exports = __webpack_public_path__ + "img/resource-zy-active.1d55cfdb.png";